<template>
  <div id="app" v-if="loggedIn()">
    <div class="top-menu">
    <el-menu class="infc-menu" mode="horizontal" @open="handleTopOpen">
      <div class="title"><img src="/static/ckmlogo.png"></div>
      <el-menu-item v-if="loggedIn()" class="infc-logout-button" index="1" @click="logout">Log Out</el-menu-item>
    </el-menu>
    </div>
    <div class="left-sub-menu" v-if="loggedIn()">
      <el-menu :default-active="activeIndex" class="el-menu-vertical" theme="dark" @open="handleOpen" @close="handleClose" :router="true">
        <el-menu-item index="/">Dashboard</el-menu-item>
        <el-menu-item index="/surveillance">Infection Surveillance</el-menu-item>
        <el-menu-item-group title="Outbreak Management"/>
        <el-menu-item-group title="Infection Threshold"/>
        <el-menu-item-group title="Infection Analysis"/>
        <el-menu-item-group title="Denominators"/>
        <el-submenu>
           <template slot="title"><i class="el-icon-setting"></i>Setup</template>
           <el-menu-item index="/clients">Residents</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="right-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import auth from './auth'

export default {
  name: 'app',
  data: function () {
    return {
      activeIndex: '/'
    }
  },
  methods: {
    loggedIn () {
      return auth.loggedIn()
    },
    logout () {
      var vm = this
      auth.logout(function () {
        console.log('hi')
        vm.activeIndex = '/'
        vm.$router.go('/')
      })
    },
    handleTopOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    reload: function () {
      this.$router.go(this.$router.currentRoute)
    }
  },
  created: function () {
    this.activeIndex = this.$router.currentRoute.path
  }
}
</script>

<style scope>
html {
  box-sizing: border-box;
}
*, *:before, *:after {
  box-sizing: inherit;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
}

body, html {
  height: 100%;
}

.top-menu {
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    z-index: 100;
}

.left-sub-menu ul.el-menu.el-menu-vertical.el-menu--dark {
  background-color: #9E9791;
}
.left-sub-menu {
    position: fixed;
    top: 60px;
    left: 0;
    bottom: 0;
    width: 180px;
    /*background: #324157;*/
    background: #9E9791;

    z-index: 100;
}

.right-content {
    position: absolute;
    left: 180px;
    top: 60px;
    right: 0;
}

.infc-menu .infc-logout-button {
  float: right;
}

.infc-menu > .title {
  font-size: 1em;
  padding-left: 10px;
  display: block;
  float: left;
  line-height: 60px;
  height: 60px;
  color: #20A0FF;
}

.infc-menu > .title > img {
  height: 50px;
  margin-top: 5px;
}

.line {
  margin-bottom: 2em;
}

html, body {
  margin: 0;
  padding: 0;
}

.section-header > .el-row {
    padding: 10px;
    background: #7cc156;
    color: white;
    font-weight: bolder;
}



.el-menu--horizontal.el-menu--dark .el-submenu .el-menu-item.is-active, .el-menu-item.is-active  {
    color: white;
    background-color: #444;
    font-weight: bolder;
}


.el-menu--dark .el-menu-item, .el-menu--dark .el-submenu__title {
    color: white;
}

.el-menu-item, .el-submenu__title {
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    color: #48576a;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    transition: border-color .3s,background-color .3s,color .3s;
    box-sizing: border-box;
    white-space: nowrap;
}

.el-picker-panel__shortcut {
    font-size: 0.8em;
}

.el-tag--warning {
  color: #454544;
}

.el-tag--success {
  color: #454544;  
}

.el-tag--danger {
  color: #454544;
}

.el-tag--primary {
  color: #454544;
}

.el-dialog__header {
    padding: 10px;
    background: #7cc156;
    color: white;
}

.el-dialog__title, .el-dialog__close {
  color: white
}

span.el-tag {
    margin: 0.2em;
}
/*.el-radio-button__orig-radio:checked+.el-radio-button__inner {
    color: #fff;
    background-color: #444;
    border-color: #444;
}

.el-menu--dark .el-menu-item:hover, .el-menu--dark .el-submenu__title:hover {
    background-color:#486a4a;
}

.el-picker-panel__shortcut {
    display: block;
    width: 100%;
    border: 0;
    background-color: transparent;
    line-height: 28px;
    font-size: 14px;
    color: #48576a;
    padding-left: 12px;
    text-align: left;
    outline: 0;
    cursor: pointer;
    font-size: 0.8em;
}

.el-pager li.active {
    border-color: #444;
    background-color: #444;
    color: #fff;
    cursor: default;
}*/
.left-sub-menu .el-submenu ul.el-menu {
    background: transparent;
}

.el-menu-item-group__title {
  line-height: 42px;
  color: lightgray;
}
</style>
<style>
  .el-dialog.el-dialog--large {
    width: 70% !important;
  }
</style>


// WEBPACK FOOTER //
// App.vue?3a288bcd